(() => {
  if (window.henceCookiePreferencesBound) return;
  window.henceCookiePreferencesBound = true;

  // Keep chat clear of both privacy surfaces, including preferences reopened later.
  // This follows their visibility, not whether the visitor accepts tracking.
  const syncChatVisibility = () => {
    const privacyOpen = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')]
      .some((panel) => {
        if (panel.hidden || panel.getAttribute('aria-hidden') === 'true') return false;
        const style = window.getComputedStyle(panel);
        return style.display !== 'none' && style.visibility !== 'hidden' &&
          style.visibility !== 'collapse' && panel.getClientRects().length > 0;
      });
    document.documentElement.classList.toggle('hence-privacy-open', privacyOpen);
  };
  const privacyObserver = new MutationObserver(syncChatVisibility);
  privacyObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
  });
  window.addEventListener('resize', syncChatVisibility);
  syncChatVisibility();

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-hence-cookie-preferences]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const status = document.getElementById(link.getAttribute('aria-describedby'));
    if (!status || link.getAttribute('aria-busy') === 'true') return;
    status.hidden = true;
    status.textContent = '';
    link.setAttribute('aria-busy', 'true');
    try {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
        throw new Error('Shopify preferences control unavailable');
      }
      await window.privacyBanner.showPreferences();
    } catch {
      status.textContent = 'Cookie preferences could not be opened. Please reload and try again. You can also read our Privacy policy.';
      status.hidden = false;
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();
